import { render, staticRenderFns } from "./TranslationsByLanguageView.vue?vue&type=template&id=b8124e8a&scoped=true&"
import script from "./TranslationsByLanguageView.vue?vue&type=script&lang=ts&"
export * from "./TranslationsByLanguageView.vue?vue&type=script&lang=ts&"
import style0 from "./TranslationsByLanguageView.vue?vue&type=style&index=0&id=b8124e8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8124e8a",
  null
  
)

export default component.exports